export default __webpack_public_path__ + "static/media/329.0a22a8c7.jpg";